export default "__VITE_ASSET__901fa834__"